import React from 'react';
import { BarChart3Icon, WalletIcon, UsersIcon, MousePointerClickIcon } from 'lucide-react';
interface KPIData {
  totalCampaigns: number;
  budget: string;
  leads: string;
  clicks: string;
}
interface KPICardsProps {
  data: KPIData;
}
export function KPICards({
  data
}: KPICardsProps) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-68">
      {/* Primary Card */}
      <div className="bg-primary text-primary-foreground rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-69">
        <div className="flex items-center justify-between" data-id="element-70">
          <span className="text-sm font-medium text-primary-foreground/80" data-id="element-71">
            Total campaigns
          </span>
          <div className="p-2.5 bg-primary-foreground/10 rounded-xl" data-id="element-72">
            <BarChart3Icon className="w-5 h-5 text-primary-foreground" data-id="element-73" />
          </div>
        </div>
        <span className="text-3xl font-bold block" data-id="element-74">{data.totalCampaigns}</span>
      </div>

      {/* Secondary Cards */}
      <div className="bg-card border border-border rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-75">
        <div className="flex items-center justify-between" data-id="element-76">
          <span className="text-sm font-medium text-muted-foreground" data-id="element-77">
            Budget
          </span>
          <div className="p-2.5 bg-muted rounded-xl" data-id="element-78">
            <WalletIcon className="w-5 h-5 text-foreground" data-id="element-79" />
          </div>
        </div>
        <span className="text-3xl font-bold text-foreground block" data-id="element-80">
          {data.budget}
        </span>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-81">
        <div className="flex items-center justify-between" data-id="element-82">
          <span className="text-sm font-medium text-muted-foreground" data-id="element-83">
            Leads
          </span>
          <div className="p-2.5 bg-muted rounded-xl" data-id="element-84">
            <UsersIcon className="w-5 h-5 text-foreground" data-id="element-85" />
          </div>
        </div>
        <span className="text-3xl font-bold text-foreground block" data-id="element-86">
          {data.leads}
        </span>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-87">
        <div className="flex items-center justify-between" data-id="element-88">
          <span className="text-sm font-medium text-muted-foreground" data-id="element-89">
            Clicks
          </span>
          <div className="p-2.5 bg-muted rounded-xl" data-id="element-90">
            <MousePointerClickIcon className="w-5 h-5 text-foreground" data-id="element-91" />
          </div>
        </div>
        <span className="text-3xl font-bold text-foreground block" data-id="element-92">
          {data.clicks}
        </span>
      </div>
    </div>;
}